// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Loader__root___WTkkP {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n", "",{"version":3,"sources":["webpack://./src/components/UI/Loader/Loader.styl"],"names":[],"mappings":"AAAA;EACE,aAAQ;EACR,mBAAY;EACZ,uBAAgB;EAChB,OAAK;AACP","sourcesContent":[".root\n  display flex\n  align-items center\n  justify-content center\n  flex 1\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Loader__root___WTkkP"
};
export default ___CSS_LOADER_EXPORT___;
